<style lang="less">
.pdf-export{
  .markdown-body h1{
    margin-top:0 !important;
  }
}
</style>
<template>
    <div style="height:100%;">
      <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border))">
        <div class="flex-wrap split5"> <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" @on-change="cached=false;getProjectData()">
          <template v-for="pr in projects">
          <Option
            :value="pr.id"
            :key="pr.id"
            :label="pr.name"
          >
          {{ pr.name }}
            <Tag>{{ pr.finished?'已完成':'进行中' }}</Tag>
            <Tag>{{ pr.group}}</Tag>
          </Option>
        </template>
        </Select>


        <Select v-model="task_id" style="width:340px" placeholder="选择模块" @on-change="getTaskData" filterable clearable>
            <OptionGroup v-for="g in tasks" :key="g.id" :label="g.name">
                <Option
                    v-for="p in g.works"
                    :value="p.id"
                    :key="p.key"
                >
                {{ p.name }}
                </Option>
            </OptionGroup>

        </Select>
        <Select v-model="model" style="width:140px" placeholder="选择模型">
          <Option
            v-for="p in models"
            :value="p.key"
            :key="p.key"
          >
          {{ p.name }}
          </Option>
        </Select>

    <BaseParserSelect v-model="userText" />
        </div>
        <Button @click="exportPDF">导出pdf</Button>

      </div>
      <div class="flex-wrap flex-between" style="align-items:stretch;height:calc(100% - 50px);border-top:1px solid var(--border);position:relative;padding:10px;width:100%;overflow:hidden;">
        <div style="border:1px dashed var(--border);height:calc(100%);flex-shrink:1;flex-grow:1;overflow:hidden;">
          <Input
            type="textarea"
            v-model="userText"
            :rows="8"
            style="width:100%;display:block"
            placeholder="请输入您的需求，尽可能详细，比如：帮我设计一个监理用表:瓶装液化气安全检查"
          />
          <div class="flex-wrap flex-between">
            <div> <Button
            style="margin:10px 0;"
            @click="getTaskData" v-if="task_id">获取数据</Button>

            <i-switch style="margin-left:10px;" size="small" v-model="extractForm" @on-change="cleanData" /> 提取表格 ({{ extractForm ? '是' : '否' }})
            <i-switch style="margin-left:10px;" size="small" v-model="onlyQuestion" @on-change="cleanData" /> 隐藏合规项 ({{ onlyQuestion ? '是' : '否' }})

           文本长度:{{ aiText.length }}</div>


           <div class="flex-wrap">
            <Button @click="CopyToClip" type="error">复制</Button>
            <!-- <Button
            type="primary"
            @click="CreateByAI"
            :loading="ai_executings">{{ai_executings?'正在努力生成,请耐心等待20-30s...':(cached?'查看报告':'生成报告')}}</Button>
            <Button
            style="margin:10px"
            v-if="cached"
            @click="CreateByAI(true)"
            :loading="ai_executings">重新生成</Button> -->
          </div>

          </div>
          <div class="flex-wrap split5" style="height:40px;padding:0 10px">
            跟踪记录
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
           <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
           <Button @click="cleanData">清理跟踪记录</Button>
           </div>


          <div class="flex-wrap flex-center pdf-export" style="height:calc(100% - 270px);background:#fff;position:relative;overflow-y:hidden;padding:10px;">
            <Input
            type="textarea"
            :value="aiText"
            :rows="25"
            style="width:100%;height:100%;display:block"
            placeholder="请输入您的需求，尽可能详细，比如：帮我设计一个监理用表:瓶装液化气安全检查"
          />
          </div>
        </div>
        <div class="pdf-export" style="width:800px;background:#fff;border:1px solid var(--border);overflow:hidden;overflow-y:auto;margin-left:10px;padding:20px 40px;align-self:flex-start;height:100%;">
           <BaseImageList :files="images" />
          <div v-for="(file,index) in images" :key="index">
            图片{{index+1}}:
            <a :href="file" target="_blank">{{file}}</a>
          </div>
          <div v-for="(file,index) in files" :key="index">
            附件{{index+1}}:
            <a :href="file" target="_blank">{{file}}</a>
          </div>
          <BaseMarkdownView  ref="content" :value="result" />
        </div>
      </div>
      <BaseLoadingModal v-model="loading" title="正在提取数据" />
    </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import html2pdf from 'html2pdf.js';
import {deepCleanTask, renderEFormMap, extractAttachments} from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
export default {
  mixins: [mixinPageState],
  data() {
    return {
      run: {},
      steps: [],
      loading: false,
      messages: {},
      models: [],
      aiText: '',
      model: 'douyin',
      data: '',
      rawTasks: [],
      tracking_startDate: null,
      pageStateKey: 'ai_work',
      pageStateFields: ['project_id', 'task_id', 'onlyQuestion', 'extractForm', 'tracking_startDate', 'tracking_endDate'],
      tracking_endDate: null,
      userText: '我们是一家监理及全过程咨询服务的公司，目前公司全面上线了任务系统。以下是一个任务的完整数据，请从监理服务质量检查和风险管控角度，严格结合以下任务数据执行全维度分析，不关联上下文数据。分五部分内容，一是任务执行总体概况（严格统计工作模块下工作任务的数量、工作任务的状态、工作跟踪记录的数量、其中工作表单的数量）；二是评估整体监理服务质量（评估工作任务是否覆盖该工作模块规范规定的主要监理工作，验证问题发现能力，提取所有\'不符合\',\'否\',\'不合格\'等质量问题（须有影像照片记录），验证每个问题是否闭环（需有对应回复内容），计算整改时效（问题发现→问题回复时长））；三是如有潜在风险请给出分析和评价（重点对问题发现数量，问题整改回复情况，记录中“/”代表本次检查无该项）；四是对工作跟踪记录执行人进行工作量统计（ 严格统计[]内的人即为工作跟踪记录执行人）。五是从项目部监理服务质量和风险管控程度对项目部进行评价，分为优秀、良好、合格、不合格',
      ai_executings: false,
      extractForm: false,
      onlyQuestion: false,
      result: '',
      images: [],
      files: [],
      tasks: [],
      task_id: '',
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
      cached: false,
      views: [
        {
          key: 'all',
          name: '全部工作',
        }, {
          key: 'finished',
          name: '已完工作',
        }, {
          key: 'allToDo',
          name: '未完工作',
        }, {
          key: 'recent',
          name: '近期工作',
        }, {
          key: 'myTodo',
          name: '我的待办',
        }, {
          key: 'today',
          name: '今日动态',
        }, {
          key: 'yestoday',
          name: '昨日动态',
        }, {
          key: 'theDayBeforeYestoday',
          name: '前日动态',
        }, {
          key: 'aboutMe',
          name: '我的工作',
        }, {
          key: 'alert',
          name: '预警工作',
        }, {
          key: 'nonActivation',
          name: '尚未启动',
        }],
    };
  },

  mounted() {
    setTimeout(()=>{
      this.getProjects();
      this.getProjectData();
      this.getModels();
    }, 500);
  },
  methods: {


    getModels() {
      this.$api.get('ai/parse/models').then((res)=>{
        this.models = res.data.data;
      });
    },
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res)=>{
        this.projects = res.data.data;
      });
    },
    exportPDF() {
      const project = this.projects.find((p)=>p.id == this.project_id);
      const opt = {
        margin: 1,
        filename: `${project.name}_${this.view}_${moment().format('YYYYMMDD')}.pdf`,
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 2}, // 提高清晰度
        jsPDF: {unit: 'in', format: 'a4', orientation: 'portrait'},
      };
      if (this.result) {
        html2pdf().set(opt).from(this.$refs.content.$el).save();
      }
    },
    getProjectData() {
      this.$api.post(`logined_zzl/get_modules`, {pid: this.project_id}).then((res)=>{
        this.tasks = res.data.data;
        console.log(this.tasks);
        if (this.tasks.length > 0) {
          const tasks = this.tasks.map((v)=>v.works).filter((v)=>Array.isArray(v) && v.length > 0);
          if (tasks.length > 0) {
            if (!this.task_id) {
              this.task_id = tasks[0][0].id;
              this.getTaskData();
            }
          }
        }
      });
    },
    getTaskData() {
      if (!this.task_id) {
        return;
      }
      this.loading = true;
      this.$api.post(`logined_zzl/get_module_data`, {id: this.task_id}).then((res)=>{
        const tasks = res.data.data;

        this.rawTasks = tasks;
        this.cleanData();
        this.loading = false;
      }).catch((e)=>{
        this.loading = false;
      });
    },

    cleanData() {
      this.__savePageState();
      this.images = [];
      this.files = [];
      const task = this.tasks.map((v)=>v.works).map((v)=>v.find((t)=>t.id == this.task_id)).filter((v)=>v)[0];
      const tasks = this.rawTasks;
      const eformmap = {};

      this.aiText = `本任务名称为【${task.name}】\n# 以下为所有任务数据\n` +tasks.map((t)=>deepCleanTask(t, this.tracking_startDate, this.tracking_endDate, null, this.extractForm?eformmap:null, this.onlyQuestion)).join('\n');
      if (this.extractForm) {
        this.aiText += renderEFormMap(eformmap);
      }
      const {images, files, text} = extractAttachments(this.aiText);
      this.images =images;
      this.files =files;
      this.aiText = text;
    },
    async CopyToClip() {
      const text = this.userText + '\n\n' + this.aiText;
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          console.log(this.Success);

          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
    CreateByAI(forced) {
      if (this.aiText.length < 10) {
        this.Error('请先点击【获取数据】，否则没有数据支持无法生成');
        return;
      }
      if (this.aiText.length > 55000) {
        this.Error('文本内容过大(暂时只支持50000字以内的处理)，建议拆分处理');
        return;
      }
      this.ai_executings = true;
      const parser = 'chat';
      fetch(this.$api.defaults.baseURL+`/ai/parse/${parser}`, {
        method: 'POST',
        body: JSON.stringify({
          'content': this.cleaned,
          'stream': true,
          'cached_id': this.project_id + '_' + parser,
          'model': this.model,
          'forced': forced?1:0,
        }), headers: {
          ...this.$api.defaults.headers,
          'Content-Type': 'application/json',
        }}).then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          response.json().then((res) => {
            this.result = res.data;
            this.ai_executings = false;
            this.cached = true;
          }).catch((err) => {
            this.ai_executings = false;
          });
          return;
        }
        const that = this;
        const reader = response.body.getReader(); // 获取流读取器
        console.log(reader);
        const decoder = new TextDecoder(); // 创建解码器
        let result = '';
        const ReadStream = ()=>{
          reader.read().then(({done, value})=>{
            if (done) {
              console.log('done');
              this.ai_executings = false;
              return;
            }
            const decodedText = decoder.decode(value, {stream: true});
            console.log(decodedText);
            result += decodedText;
            this.result = result;
            this.moveAITextareaDown();
            ReadStream();
          });
        };


        ReadStream();
      })
          .catch((e) => {
            this.Error(e);
            this.ai_executings = false;
          });
    },
    moveAITextareaDown() {
      if (this.atd_timer) {
        return;
      }
      this.atd_timer = setTimeout(()=>{
        if (this.$refs.ai_input) {
          const inputElement = this.$refs.ai_input.$el.querySelector('textarea');
          this.$nextTick(()=>{
            inputElement.scrollTop = inputElement.scrollHeight;
          });
        }
        delete this.atd_timer;
      }, 500);
    },
    chat() {
      this.$ai.post('assistants/asst_7zEHmB2fxAgcP67FLe1M5R29/threads', {
        messages: [{role: 'user', content: '如何创建一个30层的直跑楼梯'}],
      }).then((res)=>{
        this.run = res.data.data;
        if (this.run.status !== 'complete') {
          setTimeout(()=>{
            this.Refresh();
          }, 1000);
        }
      });
    },
    RefreshSteps() {
      for (let i=0; i<this.steps.length; i++) {
        const step = this.steps[i];
        if (step.status == 'in_progress') {
          step.content = 'Answer:';
          this.RefreshStep(i);
        }
      }
    },
    RefreshStep(i) {
      const step = this.steps[i];
      this.$ai.get(`runs/${this.run.id}/steps/${step.id}?thread_id=${this.run.thread_id}`, {responseType: 'stream'}).then((response)=>{
        if (response && typeof response.pipe === 'function') {
          response.on('end', () => {
            console.log('end');
          });

          response.on('data', (chunk) => {
            console.log('data:', chunk.toString('utf-8'));
          });
        }
      });
    },
    extractAttachments(taskText) {
    // 提取文本中的URL，将图片和文件分别存储，并替换原文本中的URL

      // 修改URL正则表达式，确保不包含逗号
      // 匹配http或https开头的URL，或以/开头并以特定文件扩展名结尾的路径
      // 使用负向前瞻(?!,)确保不匹配逗号
      const urlRegex = /(https?:\/\/[^\s,]+|\/[^\s,]+\.(jpeg|jpg|png|gif|bmp|webp|pdf|docx|doc|xlsx|xls|pptx|ppt|txt|zip|rar|dwg|file))/gi;
      const images = [];
      const files = [];
      let newText = taskText;

      // 查找所有匹配的URL
      const matches = taskText.match(urlRegex);
      if (matches) {
      // 初始化图片和文件数组
        this.images = [];
        this.files = [];

        matches.forEach((url) => {
        // 判断URL是否为图片
          const isImage = /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);

          if (isImage) {
          // 添加到图片数组
            images.push(url);
            // 替换原文本中的URL为[图片i]
            newText = newText.replace(url, `[图片${images.length}]`);
            if (url.startsWith('http') == false) {
              url = 'https://zzl.inbgz.com' + url;
            }
            this.images.push(url);
          } else {
          // 添加到文件数组
            files.push(url);
            // 替换原文本中的URL为[附件i]
            newText = newText.replace(url, `[附件${files.length}]`);
            this.files.push(url);
          }
        });
      }

      newText = newText.replace(/(\n)+/g, '\n');

      return newText;
    },
    RefreshMessage(message_id) {
      this.messages[message_id] = {content: ''};
      this.$ai.get(`threads/${this.run.thread_id}/message/${message_id}`, {responseType: 'stream', stream: true}).then((stream)=>{
        if (stream && stream.data) {
          stream.data.on('end', ()=>{
            console.log('end');
          });
          stream.data.on('data', (chunk)=>{
            this.messages[message_id].content += chunk.toString('utf-8');
            console.log('text:', chunk.toString('utf-8'));
          });
        }
      });
    },
    Refresh() {
      if (this.run && this.run.id) {
        this.$ai.get(`runs/${this.run.id}?thread_id=${this.run.thread_id}`).then((res)=>{
          const run = res.data.data;
          this.run.status = run.status;
          if (run.steps) {
            this.steps = run.steps;
          }
          if (this.run.status == 'queue') {
            setTimeout(()=>{
              this.Refresh();
            }, 1000);
          } else if (this.run.status == 'in_progress') {
            this.RefreshSteps();
          }
        });
      }
    },
  },
};
</script>

<style>

</style>
